import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import generalReducers from "./reducers/generalReducers"; // Import your general reducers

// Function to load state from localStorage
const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem("reduxState");
    if (serializedState) {
      return JSON.parse(serializedState); // Return the parsed state if it exists
    }
    return undefined; // Return undefined if no state exists in localStorage
  } catch (error) {
    console.error("Could not load state from localStorage", error);
    return undefined; // If there's an error, return undefined
  }
};

// Function to save state to localStorage
const saveStateToLocalStorage = (state) => {
  try {
    const serializedState = JSON.stringify(state); // Convert state to JSON
    localStorage.setItem("reduxState", serializedState); // Store in localStorage
  } catch (error) {
    console.error("Could not save state to localStorage", error);
  }
};

// Load the saved state from localStorage (if any)
const preloadedState = loadStateFromLocalStorage();

// Middleware
const middleware = [thunk];

// Create Redux store with preloaded state
const store = createStore(
  generalReducers,
  preloadedState, // Use the loaded state as the initial state
  composeWithDevTools(applyMiddleware(...middleware))
);

// Subscribe to store changes and save state to localStorage
store.subscribe(() => {
  saveStateToLocalStorage(store.getState());
});

export default store;
